// extracted by mini-css-extract-plugin
export default {"zoomModal":"y3-z","image":"z3-z","button":"A3-z","isOverlayShown":"B3-z"};